import type { FC } from 'react';

import { useEffect, useRef } from 'react';

import { useGooglePlacesAutocomplete } from '@uikit/hooks/useGooglePlacesAutocomplete';
import type { Address } from '@uikit/models';

import { MailingAddressInput } from './MailingAddressInput';

import type { MailingAddressInputConnectedProps } from './MailingAddressInput.interface';

const useAutocompleteMailingAddressInput = (
  onChange: (address: Address) => void,
) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { address } = useGooglePlacesAutocomplete(inputRef);
  useEffect(() => {
    if (address) {
      onChange({ ...address });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address?.line1, address?.city, address?.state, address?.zipcode]);
  return { inputRef };
};

export const MailingAddressInputConnected: FC<
  MailingAddressInputConnectedProps
> = ({ onChange, name, states, disabled = false }) => {
  const { inputRef } = useAutocompleteMailingAddressInput(onChange);
  return (
    <MailingAddressInput
      name={name}
      states={states}
      disabled={disabled}
      ref={inputRef}
    />
  );
};
